const EVENT_TYPES = {
  MOUSE_EVENT: 'mouseup',
  TOUCH_EVENT: 'touchend',
};

export default EVENT_TYPES;
